import React, { useState } from 'react';
import { UserIcon, PencilRulerIcon, CalendarIcon, EyeIcon, EditIcon, DownloadIcon, ShareIcon, RulerIcon, PieChartIcon, DropletIcon, TagIcon, ChevronRightIcon, ChevronLeftIcon, ListIcon, LayoutGridIcon, FoldersIcon } from 'lucide-react';
import { FolderView } from './FolderView';
// Mock data for shared designs
const sharedDesignsData = [{
  id: 'SD001',
  name: 'North Valley Project',
  description: 'Shared by AiscoEurope SAU',
  date: 'Aug 10, 2025',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 2,
  specs: {
    length: '300.00 m',
    angle: '360°',
    area: '35.00 ha',
    flow: '38.50 l/s',
    pressure: '2.20 bar'
  },
  sharedBy: 'Daniel Fernández',
  sharedDate: '2025-08-10',
  tags: ['Multi-Pivot', 'Valley']
}, {
  id: 'SD002',
  name: 'Riverside Linear Setup',
  description: 'Shared by HMB Irrigation',
  date: 'Jul 25, 2025',
  status: 'completed',
  model: 'Linear',
  pivotCount: 1,
  specs: {
    length: '350.00 m',
    angle: 'N/A',
    area: '40.00 ha',
    flow: '45.00 l/s',
    pressure: '2.50 bar'
  },
  sharedBy: 'Benny Ginter',
  sharedDate: '2025-07-25',
  tags: ['Linear', 'Riverside']
}];
export function SharedDesigns({
  searchQuery,
  selectedDealer,
  selectedRegion,
  selectedModel
}) {
  const [viewType, setViewType] = useState('grid'); // 'grid', 'list', or 'folders'
  // Filter designs based on search query and model
  const filteredDesigns = sharedDesignsData.filter(design => {
    const matchesSearch = searchQuery === '' || design.id.toLowerCase().includes(searchQuery.toLowerCase()) || design.name.toLowerCase().includes(searchQuery.toLowerCase()) || design.description.toLowerCase().includes(searchQuery.toLowerCase()) || design.sharedBy.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesModel = selectedModel === 'all' || design.model.toLowerCase().includes(selectedModel.toLowerCase());
    return matchesSearch && matchesModel;
  });
  const handleViewDesign = design => {
    console.log('Viewing design:', design);
    // Aquí implementarías la lógica para ver un diseño
  };
  return <div data-id="element-3032">
      {/* Dashboard summary */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 border-b border-gray-200 bg-gray-50" data-id="element-3033">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-3034">
          <div className="flex justify-between items-start" data-id="element-3035">
            <div data-id="element-3036">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-3037">
                Shared With Me
              </h3>
              <p className="text-4xl font-bold text-indigo-600" data-id="element-3038">
                {filteredDesigns.length}
              </p>
            </div>
            <div className="bg-indigo-100 p-2 rounded-lg" data-id="element-3039">
              <ShareIcon size={24} className="text-indigo-600" data-id="element-3040" />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-600" data-id="element-3041">
            From {new Set(filteredDesigns.map(d => d.sharedBy)).size}{' '}
            collaborators
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-3042">
          <div className="flex justify-between items-start" data-id="element-3043">
            <div data-id="element-3044">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-3045">
                Shared By
              </h3>
              <div className="mt-2" data-id="element-3046">
                {Array.from(new Set(filteredDesigns.map(d => d.sharedBy))).map((person, index) => <div key={index} className="flex justify-between text-sm mb-1" data-id="element-3047">
                    <span data-id="element-3048">{person}</span>
                    <span className="font-medium" data-id="element-3049">
                      {filteredDesigns.filter(d => d.sharedBy === person).length}
                    </span>
                  </div>)}
              </div>
            </div>
            <div className="bg-blue-100 p-2 rounded-lg" data-id="element-3050">
              <UserIcon size={24} className="text-blue-600" data-id="element-3051" />
            </div>
          </div>
        </div>
      </div>

      {/* View type toggle */}
      <div className="flex justify-between items-center px-6 py-3 bg-white border-b border-gray-200" data-id="element-3052">
        <div className="text-gray-700 font-medium" data-id="element-3053">
          {filteredDesigns.length} shared designs
        </div>
        <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-3054">
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'list' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('list')} data-id="element-3055">
            <ListIcon size={16} className="mr-1" data-id="element-3056" />
            List
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'grid' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('grid')} data-id="element-3057">
            <LayoutGridIcon size={16} className="mr-1" data-id="element-3058" />
            Grid
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'folders' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('folders')} data-id="element-3059">
            <FoldersIcon size={16} className="mr-1" data-id="element-3060" />
            Folders
          </button>
        </div>
      </div>

      {/* Designs view (grid, list, or folders) */}
      {viewType === 'folders' ? <div className="h-[calc(100vh-400px)] min-h-[400px]" data-id="element-3061">
          <FolderView designs={filteredDesigns} onViewDesign={handleViewDesign} data-id="element-3062" />
        </div> : viewType === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6" data-id="element-3063">
          {filteredDesigns.map(design => <DesignCard key={design.id} design={design} data-id="element-3064" />)}
          {filteredDesigns.length === 0 && <div className="col-span-3 text-center py-12 text-gray-500" data-id="element-3065">
              No shared designs found matching your search criteria
            </div>}
        </div> : <div className="overflow-x-auto" data-id="element-3066">
          <table className="w-full" data-id="element-3067">
            <thead className="bg-gray-50" data-id="element-3068">
              <tr data-id="element-3069">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3070">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3071">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3072">
                  Shared By
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3073">
                  Model
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3074">
                  Specs
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3075">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3076">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-3077">
              {filteredDesigns.map(design => <tr key={design.id} className="hover:bg-gray-50" data-id="element-3078">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-3079">
                    {design.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-3080">
                    <div className="font-medium" data-id="element-3081">{design.name}</div>
                    <div className="text-gray-500 text-xs" data-id="element-3082">
                      {design.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-3083">
                    <div className="flex items-center" data-id="element-3084">
                      <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center mr-2" data-id="element-3085">
                        <UserIcon size={16} className="text-indigo-600" data-id="element-3086" />
                      </div>
                      <div data-id="element-3087">
                        {design.sharedBy}
                        <div className="text-xs text-gray-500" data-id="element-3088">
                          {design.date}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-3089">
                    <div className="flex items-center" data-id="element-3090">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-8 mr-2" data-id="element-3091" />
                      <div data-id="element-3092">
                        {design.model}
                        <div className="text-xs text-gray-500" data-id="element-3093">
                          {design.pivotCount}{' '}
                          {design.pivotCount === 1 ? 'unit' : 'units'}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-3094">
                    <div className="flex gap-2 text-xs" data-id="element-3095">
                      <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-3096">
                        {design.specs.length}
                      </span>
                      <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full" data-id="element-3097">
                        {design.specs.area}
                      </span>
                      <span className="bg-teal-50 text-teal-700 px-2 py-0.5 rounded-full" data-id="element-3098">
                        {design.specs.flow}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-3099">
                    <StatusBadge status={design.status} data-id="element-3100" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-3101">
                    <div className="flex space-x-2" data-id="element-3102">
                      <button className="text-blue-600 hover:text-blue-800" data-id="element-3103">
                        <EyeIcon size={16} data-id="element-3104" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-3105">
                        <EditIcon size={16} data-id="element-3106" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-3107">
                        <ShareIcon size={16} data-id="element-3108" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {filteredDesigns.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-3109">
              No shared designs found matching your search criteria
            </div>}
        </div>}
    </div>;
}
// Helper component for design cards
function DesignCard({
  design
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'active':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'pending':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-3110">
      <div className="p-5 border-b border-gray-100" data-id="element-3111">
        <div className="flex justify-between items-start" data-id="element-3112">
          <div data-id="element-3113">
            <div className="flex items-center" data-id="element-3114">
              <h3 className="font-bold text-gray-900 truncate max-w-[200px]" data-id="element-3115">
                {design.name}
              </h3>
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full" data-id="element-3116">
                {design.id}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-1" data-id="element-3117">{design.description}</p>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(design.status)}`} data-id="element-3118">
            {design.status.charAt(0).toUpperCase() + design.status.slice(1)}
          </span>
        </div>
        <div className="mt-4 flex items-center" data-id="element-3119">
          <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center mr-2" data-id="element-3120">
            <UserIcon size={16} className="text-indigo-600" data-id="element-3121" />
          </div>
          <div data-id="element-3122">
            <div className="text-sm font-medium text-gray-900" data-id="element-3123">
              Shared by: {design.sharedBy}
            </div>
            <div className="text-xs text-gray-500 flex items-center" data-id="element-3124">
              <CalendarIcon size={10} className="mr-1" data-id="element-3125" />
              {design.date}
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 py-4 flex justify-between items-center bg-gray-50 border-b border-gray-100" data-id="element-3126">
        <div className="flex items-center" data-id="element-3127">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-12 mr-3" data-id="element-3128" />
          <div data-id="element-3129">
            <div className="text-sm font-medium text-gray-900" data-id="element-3130">
              {design.model}
            </div>
            <div className="text-xs text-gray-500" data-id="element-3131">
              {design.pivotCount} {design.pivotCount === 1 ? 'unit' : 'units'}
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 py-4" data-id="element-3132">
        <h4 className="text-xs font-medium text-gray-500 mb-2" data-id="element-3133">
          SPECIFICATIONS
        </h4>
        <div className="grid grid-cols-3 gap-2" data-id="element-3134">
          <div className="bg-blue-50 rounded-lg p-2 text-center" data-id="element-3135">
            <div className="text-xs text-blue-600 mb-1 flex items-center justify-center" data-id="element-3136">
              <RulerIcon size={12} className="mr-1" data-id="element-3137" />
              Length
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3138">
              {design.specs.length}
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-2 text-center" data-id="element-3139">
            <div className="text-xs text-indigo-600 mb-1 flex items-center justify-center" data-id="element-3140">
              <PieChartIcon size={12} className="mr-1" data-id="element-3141" />
              Area
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3142">
              {design.specs.area}
            </div>
          </div>
          <div className="bg-teal-50 rounded-lg p-2 text-center" data-id="element-3143">
            <div className="text-xs text-teal-600 mb-1 flex items-center justify-center" data-id="element-3144">
              <DropletIcon size={12} className="mr-1" data-id="element-3145" />
              Flow
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3146">
              {design.specs.flow}
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1" data-id="element-3147">
          {design.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-3148">
              <TagIcon size={10} className="mr-1" data-id="element-3149" />
              {tag}
            </span>)}
        </div>
      </div>
      <div className="px-5 py-3 border-t border-gray-100 flex justify-between" data-id="element-3150">
        <div className="flex space-x-2" data-id="element-3151">
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center" data-id="element-3152">
            <EyeIcon size={14} className="mr-1" data-id="element-3153" />
            View
          </button>
          <button className="text-gray-600 hover:text-gray-800 text-sm font-medium flex items-center" data-id="element-3154">
            <EditIcon size={14} className="mr-1" data-id="element-3155" />
            Edit
          </button>
        </div>
        <div className="flex space-x-2" data-id="element-3156">
          <button className="text-gray-600 hover:text-gray-800" data-id="element-3157">
            <ShareIcon size={16} data-id="element-3158" />
          </button>
          <button className="text-gray-600 hover:text-gray-800" data-id="element-3159">
            <DownloadIcon size={16} data-id="element-3160" />
          </button>
        </div>
      </div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    text: 'Unknown'
  };
  switch (status) {
    case 'active':
      config = {
        color: 'blue',
        text: 'Active'
      };
      break;
    case 'completed':
      config = {
        color: 'green',
        text: 'Completed'
      };
      break;
    case 'pending':
      config = {
        color: 'amber',
        text: 'Pending'
      };
      break;
  }
  const colors = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    amber: 'bg-amber-100 text-amber-800',
    gray: 'bg-gray-100 text-gray-800'
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[config.color]}`} data-id="element-3161">
      {config.text}
    </span>;
}